<template>
  <v-container class="disclaimer-container">
    <!-- Button to trigger the overlay -->
    <v-btn color="info" tile small block @click="show = true">Disclaimer</v-btn>

    <!-- Overlay for the disclaimer -->
    <v-dialog v-model="show" max-width="600px" persistent>
      <v-card class="disclaimer-card">
        <!-- Close Icon -->
        <v-icon
          class="close-icon"
          @click="show = false"
          color="white"
          size="32"
        >
          mdi-close
        </v-icon>

        <v-card-text class="disclaimer-content pa-6">
          <h3 class="text-h6 mb-4">Disclaimer</h3>

          <p class="mb-4">
            Cawthron has used all reasonable endeavors to ensure that the
            information contained on this website is accurate. However, Cawthron
            does not provide any express or implied warranty regarding the
            accuracy of the information available on this site.
          </p>

          <p class="mb-4">
            This website is intended to offer information about wind, waves,
            water temperature, and barometric pressure at the buoys' location at
            the recorded time. It is the responsibility of the user to make
            their own decisions and interpretations about marine conditions
            based on this data.
          </p>

          <p class="mb-0">
            Please use the data with caution, especially where there could be
            safety, monetary, or operational consequences if the data is
            incorrect.
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style scoped>
.disclaimer-container {
  position: relative;
}

.disclaimer-card {
  position: relative;
  overflow-y: auto;
  max-height: 90vh;
  background-color: #01a8ba;
  color: white;
}

.close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  z-index: 2;

  border-radius: 4px;
  padding: 4px;
  color: #01a8ba;
}

.disclaimer-content {
  font-size: 1rem;
  line-height: 1.6;
}

/* Mobile adjustments */
@media (max-width: 600px) {
  .disclaimer-card {
    margin: 3rem 0 0 0;
    max-height: 80vh;
  }

  .disclaimer-content {
    font-size: 0.875rem;
    padding: 16px !important;
  }
}

/* Scrollbar styling */
.disclaimer-card::-webkit-scrollbar {
  width: 8px;
}

.disclaimer-card::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.disclaimer-card::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.disclaimer-card::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
